define('dataSource/analytics/analyticsRegistry',['knockout', 'lodash'],
    function(ko, _) {
        'use strict';
        /**
         * observable for list of registries
         * @type {Array}
         */
        var registryList = ko.observableArray([]);
        /**
         * computed observable for number of loading dataSources for analytics
         * @type {integer}
         */
        var numLoading = ko.computed({
            read: computeNumLoading,
            deferEvaluation: true
        });

        return {
            numLoading: numLoading,
            push: addRegistry
        };

        /**
         * function to compute num of dataSources related to analytics view are loading
         * @return {interger} number of dataSources related to analytics view are loading
         */
        function computeNumLoading() {
                var numLoading = _.reduce(registryList(), function(sum, loadingObs) {
                    return sum + !!loadingObs();
                }, 0);
                return numLoading;
            }
            /**
             * function to add registry of isLoading observable
             * @param {ko.observable} loadingObs registed observable that holds
             * the logic that the corresponding datasource is currently loading or not
             */
        function addRegistry(loadingObs) {
            registryList.push(loadingObs);
        }
    });
